import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, scrollToId } from "./data";
import { INTRO } from "./Reveal";
import { Magnetic } from "./Magnetic";
import { PriceTicker } from "./PriceTicker";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: INTRO + 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${scrolled || open ? "bg-white/80 shadow-[0_1px_0_rgba(10,26,51,0.08)] backdrop-blur-xl" : "bg-transparent"}`}
      data-testid="site-header"
    >
      <PriceTicker />
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <button onClick={() => go("top")} data-testid="header-logo-link" aria-label="Zenura Metals home"><Logo /></button>
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} data-testid={`nav-link-${n.id}`} className="nav-link text-sm font-medium text-slate-700 hover:text-navy">
              {n.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Magnetic className="hidden sm:inline-block">
            <button onClick={() => go("contact")} data-testid="header-cta-button" className="group flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-gold">
              Start an enquiry <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
            </button>
          </Magnetic>
          <button onClick={() => setOpen((o) => !o)} className="grid h-10 w-10 place-items-center rounded-full border border-navy/15 lg:hidden" data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} className="overflow-hidden lg:hidden" data-testid="mobile-menu">
            <div className="flex flex-col gap-1 px-5 pb-6">
              {NAV.map((n) => (
                <button key={n.id} onClick={() => go(n.id)} data-testid={`mobile-nav-link-${n.id}`} className="border-b border-navy/10 py-3 text-left font-display text-2xl font-bold text-navy">
                  {n.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
